import React, { useEffect, useRef } from 'react'
import * as Plot from '@observablehq/plot'
import { PlotOptions } from '@observablehq/plot'

type Props = {
  data: number[]
  options?: PlotOptions
}

export default function Histogram({ data, options }: Props) {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (data === undefined) return
    const plot = Plot.plot({
      marks: [
        Plot.rectY(
          { length: 100 },
          Plot.binX(
            { y: 'count' },
            { x: data, thresholds: 'freedman-diaconis', tip: 'x', fill: 'var(--green-50)' },
          ),
        ),
      ],
      ...options,
    })

    if (containerRef?.current) {
      containerRef.current.append(plot)
    }

    return () => plot.remove()
  }, [data])

  return <div ref={containerRef} />
}
